import { render } from "./CostTypes.vue?vue&type=template&id=634e45ec"
import script from "./CostTypes.vue?vue&type=script&lang=ts"
export * from "./CostTypes.vue?vue&type=script&lang=ts"
script.render = render

export default script